import { CircuitoResoData } from "./CircuitoResoData";
import React, { useState, useContext } from "react";
import { PortalContext } from "../../../context/Provider";
import { setCircuitoReso } from "../../../context/Actions/turnos/estudioTurnos";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import HeaderModal from "../headerModal/headerModal";
import "./Circuito.css";
import { GlobalContext } from "../../../../global/context/Provider";
import InputV1 from "../InputV1/InputV1";

const CircuitoReso = ({ titulo, dissmiss, danger, texto, completarFormulario }) => {
  const { estudioTurnosDispatch, estudioTurnosState } =
    useContext(PortalContext);

  // Toaster Global
  const { toasterDispatch } = useContext(GlobalContext);

  const [circuitoFiltrado, setCircuitoFiltrado] = useState(CircuitoResoData);

  const onChangeRadio = (e) => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoReso);
    let arrX = circuitoFiltrado;
    if (e.target.name === "contraste" && e.target.value === "true") {
      setCircuitoReso({
        ...x,
        [e.target.name]: true,
      })(estudioTurnosDispatch);

      arrX = arrX.map((item) =>
        item.name === "renal" ? { ...item, [`visible`]: true } : item
      );
    } else if (e.target.name === "contraste" && e.target.value === "false") {
      setCircuitoReso({
        ...x,
        renal: false,
        contraste: false,
      })(estudioTurnosDispatch);
      arrX = arrX.map((item) =>
        item.name === "renal"
          ? { ...item, [`visible`]: false, [`valor`]: null }
          : item
      );
    } else {
      setCircuitoReso({
        ...x,
        [e.target.name]: e.target.value === "true" ? true : false,
      })(estudioTurnosDispatch);
    }
    arrX = arrX.map((item) =>
      item.name === e.target.name
        ? { ...item, [`valor`]: e.target.value === "true" ? true : false }
        : item
    );

    setCircuitoFiltrado(arrX);
  };

  const onClickVolverCirc = () => {
    setCircuitoFiltrado(CircuitoResoData);
    dissmiss();
  };

  const onClickBusqCirc = () => {
    let x = Object.assign({}, estudioTurnosState.estudioTurnos.circuitoReso);
    let arrX = circuitoFiltrado;
    arrX = arrX.filter((item) => (item.visible === true ? item : ""));
    arrX = arrX.filter((item) => item.valor === null);
    if (arrX.length > 0) {
      showToaster(
        {
          texto: "Complete las preguntas!",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    } else {
      setCircuitoFiltrado(CircuitoResoData);
      // completarFormulario("RESO", x)
      setCircuitoReso({
        ...x,
        flgForm: true,
      })(estudioTurnosDispatch);
    }
  };

  return (
    <>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} danger={danger} />
      <div className="ptur-circuito-bodyModal">
        <div className="ptur-circuito-tituloDesc">
          <p className="rb18l titulo-circuito">{texto}</p>
        </div>
        <div className="ptur-circuito-box">
          {circuitoFiltrado.map((item, index) => {
            return (
              <React.Fragment key={index}>
                {item.visible && (
                  <div className="ptur-circuito-boxPreguntas">
                    <div className="ptur-circuito-preguntaDesc">
                      <span className="rb14l">{item.pregunta}</span>
                    </div>
                    <div className="ptur-circuito-radios">
                      <span>
                        <InputV1
                          nombreRadio={item.name}
                          onChange={onChangeRadio}
                          value={true}
                          inputType="radio"
                          labelStr={"Sí"}
                          radioClass="ptur-circuito-radio"
                        />
                      </span>
                      <span>
                        <InputV1
                          nombreRadio={item.name}
                          onChange={onChangeRadio}
                          value={false}
                          inputType="radio"
                          labelStr={"No"}
                          radioClass="ptur-circuito-radio"
                        />
                      </span>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>
        <div className="ptur-circuito-boxBtn">
          <button
            className="ptur-circuito-btnVolver c-latex30 rb16m"
            onClick={onClickVolverCirc}
          >
            Volver
          </button>
          <button
            className="ptur-circuito-btnBusq c-white rb16m"
            onClick={onClickBusqCirc}
          >
            Buscar turnos
          </button>
        </div>
      </div>
    </>
  );
};

export default CircuitoReso;
